import setActiveMenuItem from "../functions/setActiveMenuItem";
import {
  facebook_share_for_support,
  twitter_share_for_support,
  setCopiedBtn,
  setupShareIcons,
} from "../functions/storyShareFeatures";

// TODO: esbuildへの移行時にsetActiveMenuItemのインポート方法や
// setupPageForStories()の配置場所を変更するなどリファクタリング必須

function setupPageForStories() {
  facebook_share_for_support(Routes);
  twitter_share_for_support(Routes);
  const shareIcons = document.querySelectorAll(".jsInitializeStoryShare");
  setupShareIcons(shareIcons);
}

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.stories.index").length) return;
  $("#jsStoriesPath").addClass("active");
  setupPageForStories();
});

$(() => {
  if (!$("body.stories.hash_tags.show").length) return;
  setActiveMenuItem();
});

// WARNING&&TODO:
// 現在の仕様では、以下の「body.stories.show」は複数のページのロジックをまとめているので、修正が必要。
// 1. ハッシュ(例：「#プロジェクト発足への想い」)をクリックした後に表示される内容
// 2. ストーリー記事ページ
// 3. 団体管理画面から遷移されるストーリー記事ページのプレビュー

$(() => {
  if (!$("body.stories.show").length) return;
  setupPageForStories();
  // 応援ボタンが一種類なので最初からフラグを立てる(modal_publish用)
  $(".jsInitializeStoryShare").attr("data-clicked", "1");

  // model_shareで全体を表示
  $(".jsShowFullModal").click(() => {
    document.getElementById("jsFullModal").style.display = "block";
  });
  // model_shareでボタンのみを表示
  $("#jsShowSmallModal").click(() => {
    document.getElementById("jsFullModal").style.display = "none";
  });

  // NOTE: ストーリー新規作成後にのみ団体ユーザーによって使用される
  setCopiedBtn(); // 応援依頼をコピーするボタン
});
